import { render } from "./TheAlarmPage.vue?vue&type=template&id=571795e9"
import script from "./TheAlarmPage.vue?vue&type=script&lang=js"
export * from "./TheAlarmPage.vue?vue&type=script&lang=js"

import exportComponent from "/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__